import React from 'react'
import Home from './displays/home/home'

export default function App() {
  return (
    <div><Home /></div>
  )
}

